export const LOCAL_STORAGE_CART_TOKEN_KEY = 'cart_token_value';
